import "./presurveypage.css";

import { Button, Container, Form, ProgressBar, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useApi } from "../../contexts/ApiProvider";
import { useUser } from "../../contexts/UserProvider";
import { useNavigate } from "react-router-dom";
import { userActions } from "../../actions/UserActions";


export function UserQuestionnaire({ context }) {
  const { user } = useUser();
  const navigate = useNavigate();

  // const [selectedGender, setSelectedGender] = useState("");
  // const [specifiedGender, setSpecifiedGender] = useState("");
  const [selectedHospType, setSelectedHospType] = useState("");
  const [specifiedHospType, setSpecifiedHospType] = useState("");
  const [errors, setErrors] = useState({});
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const api = useApi();
  const dispatch = useDispatch();

  const store_form = useSelector((state) => state.user.presurvey_form.form);
  const submitted = useSelector((state) => state.user.presurvey_form.submitted);

  const [formData, setFormData] = useState(store_form);

  useEffect(() => {
    setFormData(store_form);
  }, [store_form]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedValue = value.trim() === "" ? null : value;
    setFormData({
      ...formData,
      [name]: updatedValue,
    });
  };

  const handleIntChange = (e, min = null, max = null) => {
    const { name, value } = e.target;
  
    const floatValue = parseFloat(value);
  
    // Check if input is empty
    if (value.trim() === "") {
      setFormData({ ...formData, [name]: null });
      setErrors({ ...errors, [name]: "" });
      return;
    }
  
    // Check if it's a valid float
    if (!/^\d*\.?\d*$/.test(value)) {
      setErrors({ ...errors, [name]: "❗Please enter a valid number." });
    } else if ((min !== null && floatValue < min) || (max !== null && floatValue > max)) {
      setErrors({
        ...errors,
        [name]: `❗Value must be between ${min} and ${max}.`,
      });
    } else {
      setErrors({ ...errors, [name]: "" });
    }
  
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleLikertChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  

  // const handleGenderChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "gender") {
  //     setSelectedGender(value);
  //     if (value === "Other") {
  //       setFormData({
  //         ...formData,
  //         gender: specifiedGender,
  //       });
  //     } else {
  //       setFormData({
  //         ...formData,
  //         gender: value,
  //       });
  //     }
  //   } else if (name === "specifiedGender") {
  //     setSpecifiedGender(value);
  //     setFormData({
  //       ...formData,
  //       gender: value,
  //     });
  //   }
  // };

  const handleHospTypeChange = (e) => {
    const { name, value } = e.target;

    if (name === "hospital_type") {
      setSelectedHospType(value);
      if (value === "Other") {
        setFormData({
          ...formData,
          hospital_type: specifiedHospType,
        });
      } else {
        setFormData({
          ...formData,
          hospital_type: value,
        });
      }
    } else if (name === "specifiedHospType") {
      setSpecifiedHospType(value);
      setFormData({
        ...formData,
        hospital_type: value,
      });
    }
  };

  const checkForMissingFields = () => {
    const requiredFields = [
      { name: "age", question: "1. Age" },
      { name: "position", question: "2. Current or most recent role/position" },
      { name: "hospital", question: "3a. Hospital" },
      { name: "hospital_type", question: "3b. Hospital Type" },
      { name: "beds", question: "3c. Total number of hospital beds" },
      { name: "experience_pq", question: "4. Years of professional (post-qualification) experience" },
      { name: "experience_ipc", question: "5. Years of infection prevention and control experience" },
      { name: "wgs_routine_in_hospital", question: "6. Is the use of whole genome sequencing for infection prevention and control routine in your hospital?" },
      { name: "wgs_last_used", question: "7. When was the last time you have used whole genome sequencing for infection prevention and control?" },
      { name: "tech_proficiency", question: "8. Proficiency in using digital technology" },
      { name: "trace_proficiency", question: "9. Proficiency in performing contact tracing in hospitals" },
      { name: "genetic_proficiency", question: "10. Proficiency in interpreting pathogen sequencing information" },
      { name: "overlap_usefulness", question: "11. Usefulness of a graphical representation of patient movement and ward overlap information" },
      { name: "genetic_usefulness", question: "12. Usefulness of pathogen sequencing information" },
    ];

    const missing = requiredFields
      .filter(field => !formData[field.name])
      .map(field => field.question);

    setMissingFields(missing);

    return missing.length > 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (checkForMissingFields()) {
      setShowConfirmation(true);
      return;
    }

    submitForm();
  };

  const handleNavigate = () => {
    // Flash tutorial once
    sessionStorage.setItem("showTutorialOnNextPage", "true");
    console.log("showTutorialOnNextPage set to true");

    navigate("/");
  };

  const submitForm = async () => {
    const updatedForm = {
      ...formData,
      id: Number(user.id),
      submitted: true,
    };

    dispatch(userActions.updatePreSurveySelection(updatedForm));
    dispatch(userActions.submitPreSurvey());

    if (!store_form.submitted) {
      await api.post("/me/presurvey", updatedForm);
    }
    
    handleNavigate();
  };

  return (
    <Container
      style={{
        position: "relative",
        top: "20%",
        paddingLeft: "15%",
        minHeight: "100vh",
      }}
    >
      <div className="progress-container">
        <div style={{ width: "100%", textAlign: "center", marginBottom: "10px" }}>
          <ProgressBar>
            <ProgressBar now={20} label="1. Introduction" key={1} variant="secondary" />
            <ProgressBar now={20} label="2. Participant Information & Consent" key={2} variant="secondary" />
            <ProgressBar now={20} label="3. Pre-study Survey" key={3} variant="primary" />
            <ProgressBar now={20} label="4. Main Study" key={4} variant="secondary" />
            <ProgressBar now={20} label="5. Post-study Survey" key={5} variant="secondary" />
          </ProgressBar>
        </div>
      </div>
      <div className="userQ-popup-container">
        <div className="userQ-popup-content">
          <h1 className="form-title" style={{textAlign: "center", color: '#093a73', fontWeight: 600, fontSize: 36}}>Pre-Study Questionnaire</h1>{" "}
          <p style={{textAlign: "center", color: 'grey'}}>Please complete the survey below.</p>
          <br />
          <br />
          <form>
            <h5 style={{color: '#093a73' }}>▍Section A: Participant Demographics</h5>
            <Form.Group>
              <Form.Label>
                <span style={{ fontWeight: 500 }}>1. Age: </span>{" "}
                <input
                  type="text"
                  value={formData.age || ""}
                  name="age"
                  onChange={(e) => handleIntChange(e, 18, 120)}
                  pattern="\d*"
                  min="18"
                  style={{ width: "100px", marginRight: "5px" }}
                />{" "}
                years
                {errors.age && <span className="error-message">{errors.age}</span>}
              </Form.Label>
            </Form.Group>
            {/* <Form.Group>
              <Form.Label>
                <strong>2. Gender:</strong>
              </Form.Label>
              {[
                "Male",
                "Female",
                "Non-binary",
                "I prefer not to say",
                "Other",
              ].map((label) => (
                <Form.Check
                  name="gender"
                  type={"radio"}
                  id={`gender-${label}`}
                  key={`gender-${label}`}
                  label={`${label}`}
                  onChange={handleGenderChange}
                  value={label || ""}
                  checked={selectedGender === label}
                />
              ))}
              {selectedGender === "Other" && (
                <input
                  style={{ marginLeft: "13%" }}
                  type="text"
                  name="specifiedGender"
                  value={specifiedGender || ""}
                  onChange={handleGenderChange}
                  placeholder="Please specify"
                />
              )}
            </Form.Group> */}
            <h5 style={{ marginTop: "50px", color: '#093a73' }}>▍Section B: Professional Details</h5>
            <Form.Group>
              <Form.Label>
              <span style={{ fontWeight: 500 }}>2. Current or most recent role/position:</span>{" "}
                <input
                  type="text"
                  value={formData.position || ""}
                  name="position"
                  placeholder=" e.g. IPC Nurse/Clinician, Consultant Microbiologist, ..."
                  onChange={handleChange}
                  size="50"
                />{" "}
              </Form.Label>
            </Form.Group>
            <Form.Group>
              <Form.Label>
              <span style={{ fontWeight: 500 }}>3a. Hospital and Country:</span>{" "}
                <input
                  type="text"
                  value={formData.hospital || ""}
                  name="hospital"
                  placeholder=" e.g. John Radcliffe Hospital, Oxford, UK"
                  onChange={handleChange}
                  size="50"
                />{" "}
              </Form.Label>
            </Form.Group>
            <Form.Group>
              <Form.Label>
              <span style={{ fontWeight: 500 }}>3b. Hospital Type</span>
              </Form.Label>
              {[
                "University Teaching Hospital",
                "District General Hospital",
                "Other",
              ].map((label) => (
                <div key={`hospital_type-${label}`} className="d-flex align-items-center">
                  <Form.Check
                    name="hospital_type"
                    type="radio"
                    id={`hospital_type-${label}`}
                    label={label}
                    onChange={handleHospTypeChange}
                    value={label || ""}
                    checked={selectedHospType === label}
                  />
                  {label === "Other" && selectedHospType === "Other" && (
                    <input
                      className="ms-2"
                      type="text"
                      name="specifiedHospType"
                      value={specifiedHospType || ""}
                      onChange={handleHospTypeChange}
                      placeholder=" Please specify"
                      size="50"
                    />
                  )}
                </div>
              ))}
            </Form.Group>
            <Form.Group>
              <Form.Label>
              <span style={{ fontWeight: 500 }}>3c. Total number of hospital beds:</span>{" "}
                <input
                  type="text"
                  value={formData.beds || ""}
                  name="beds"
                  onChange={handleIntChange}
                  placeholder=" e.g. 1500"
                  pattern="\d*"
                  style={{ width: "100px", marginRight: "5px" }}
                />{" "}
              </Form.Label>
              (rounded to the nearest 100)
              {errors.beds && <span className="error-message">{errors.beds}</span>}
            </Form.Group>
            <Form.Group>
              <Form.Label>
                <span style={{ fontWeight: 500 }}>4. Years of professional (post-qualification) experience:</span>{" "}
                <input
                  type="text"
                  value={formData.experience_pq || ""}
                  name="experience_pq"
                  onChange={(e) => handleIntChange(e, 0, 100)}
                  pattern="\d*"
                  style={{ width: "100px", marginRight: "5px" }}
                />{" "}
                year(s)
                {errors.experience_pq && <span className="error-message">{errors.experience_pq}</span>}
              </Form.Label>
            </Form.Group>
            <Form.Group>
              <Form.Label>
                <span style={{ fontWeight: 500 }}>5. Years of infection prevention and control experience:</span>{" "}
                <input
                  type="text"
                  value={formData.experience_ipc || ""}
                  name="experience_ipc"
                  onChange={(e) => handleIntChange(e, 0, 100)}
                  pattern="\d*"
                  style={{ width: "100px", marginRight: "5px" }}
                />{" "}
                year(s)
                {errors.experience_ipc && <span className="error-message">{errors.experience_ipc}</span>}
              </Form.Label>
            </Form.Group>
            <Form.Group>
              <Form.Label>
                <span style={{ fontWeight: 500 }}>6. Is the use of whole genome sequencing for infection prevention and control routine in your hospital? </span>
              </Form.Label>
              {["Yes", "No", "Not sure"].map((label) => (
                <Form.Check
                  name="wgs_routine_in_hospital"
                  type={"radio"}
                  id={`wgs_routine_in_hospital-${label}`}
                  key={`wgs_routine_in_hospital-${label}`}
                  label={label}
                  onChange={handleChange}
                  value={label || ""}
                  checked={formData.wgs_routine_in_hospital === label}
                />
              ))}
            </Form.Group>
            <Form.Group>
              <Form.Label>
                <span style={{ fontWeight: 500 }}>7. When was the last time you have used whole genome sequencing for infection prevention and control? </span>
              </Form.Label>
              {["Never", "More than 12 months ago", "Within the last 12 months", "Within the last 3 months"].map((label) => (
                <Form.Check
                  name="wgs_last_used"
                  type={"radio"}
                  id={`wgs_last_used-${label}`}
                  key={`wgs_last_used-${label}`}
                  label={label}
                  onChange={handleChange}
                  value={label || ""}
                  checked={formData.wgs_last_used === label}
                />
              ))}
            </Form.Group>
            <h5 style={{ marginTop: "50px", color: '#093a73' }}>▍Section C: Skill Assessment</h5>
            <Form.Group>
              <Form.Label>
                <span style={{ fontWeight: 500 }}>8. How would you rate your proficiency in using digital technology?</span>
              </Form.Label>
              <div className="likert-scale">
              {[...Array(10).keys()].map((num) => (
                <Button
                  key={num + 1}
                  variant={formData.tech_proficiency === num + 1 ? "primary" : "outline-secondary"}
                  onClick={() => handleLikertChange("tech_proficiency", num + 1)}
                  className="likert-button"
                >
                  {num + 1}
                </Button>
              ))}
            </div>
            <div style={{color: 'grey', fontSize: '0.9em'}}>(1 = Not at all proficient)&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(10 = Extremely proficient)</div>
            </Form.Group>
            <Form.Group>
              <Form.Label style={{ marginTop: "30px" }}>
                <span style={{ fontWeight: 500 }}>9. How would you rate your proficiency in performing contact tracing in hospitals for infections such as <i>Clostridioides difficile</i> (C. diff)?</span>
              </Form.Label>
              <div className="likert-scale">
              {[...Array(10).keys()].map((num) => (
                <Button
                  key={num + 1}
                  variant={formData.trace_proficiency === num + 1 ? "primary" : "outline-secondary"}
                  onClick={() => handleLikertChange("trace_proficiency", num + 1)}
                  className="likert-button"
                >
                  {num + 1} 
                </Button>
              ))}
            </div>
            <div style={{color: 'grey', fontSize: '0.9em'}}>(1 = Not at all proficient)&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(10 = Extremely proficient)</div>
            </Form.Group>
            <Form.Group>
              <Form.Label style={{ marginTop: "30px" }}>
                <span style={{ fontWeight: 500 }}>10.	How would you rate your proficiency in interpreting pathogen sequencing information for contact tracing purposes/genomic surveillance?</span>
              </Form.Label>
              <div className="likert-scale">
              {[...Array(10).keys()].map((num) => (
                <Button
                  key={num + 1}
                  variant={formData.genetic_proficiency === num + 1 ? "primary" : "outline-secondary"}
                  onClick={() => handleLikertChange("genetic_proficiency", num + 1)}
                  className="likert-button"
                >
                  {num + 1} 
                </Button>
              ))}
            </div>
            <div style={{color: 'grey', fontSize: '0.9em'}}>(1 = Not at all proficient)&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(10 = Extremely proficient)</div>
            </Form.Group>
            <h5 style={{ marginTop: "50px", color: '#093a73' }}>▍Section D: Pre-Study Perceptions of an IPC Dashboard</h5>
            <Form.Group>
            <Form.Label>
              <span style={{ fontWeight: 500 }}>11. How useful do you think a graphical representation of patient movement and ward overlap information would be for infection prevention and control in your hospital?</span>
            </Form.Label>
            <div className="likert-scale">
            {[...Array(10).keys()].map((num) => (
              <Button
                key={num + 1}
                variant={formData.overlap_usefulness === num + 1 ? "primary" : "outline-secondary"}
                onClick={() => handleLikertChange("overlap_usefulness", num + 1)}
                className="likert-button"
              >
                {num + 1}
              </Button>
            ))}
          </div>
          <div style={{color: 'grey', fontSize: '0.9em'}}>(1 = Not at all useful)&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(10 = Extremely useful)</div>
          </Form.Group>
          <Form.Group>
            <Form.Label style={{ marginTop: "30px" }}>
              <span style={{ fontWeight: 500 }}>12. How useful do you think pathogen sequencing information would be for infection prevention and control in your hospital?</span>
            </Form.Label>
            <div className="likert-scale">
            {[...Array(10).keys()].map((num) => (
              <Button
                key={num + 1}
                variant={formData.genetic_usefulness === num + 1 ? "primary" : "outline-secondary"}
                onClick={() => handleLikertChange("genetic_usefulness", num + 1)}
                className="likert-button"
              >
                {num + 1} 
              </Button>
            ))}
          </div>
          <div style={{color: 'grey', fontSize: '0.9em'}}>(1 = Not at all useful)&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(10 = Extremely useful)</div>
          </Form.Group>
          </form>
          <br />
          <Button className="blue-button-form" onClick={handleSubmit}>
            Submit & Proceed
          </Button>
        </div>
      </div>

      {/* Confirmation Modal */}
      <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Incomplete Questionnaire</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Some responses are missing:</p>
          <ul>
            {missingFields.map((field, index) => (
              <li key={index}><strong>{field}</strong></li>
            ))}
          </ul>
          <p>Would you still like to submit the questionnaire?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmation(false)}>
            No, go back
          </Button>
          <Button variant="primary" onClick={() => { setShowConfirmation(false); submitForm(); }}>
            Yes, submit anyway
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}